/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-contrib
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function ($) {
    'use strict';
    $('[data-ui=tabs]').each(function () {
        var $t = $(this);
        var $allLinks = $t.find('a[data-ui=tabs-tab]');
        var hideTabs = function (id) {
            $allLinks.each(function () {
                var $this = $(this);
                if ($this.attr('href') !== id) {
                    $this.parent().removeClass('active');
                    $($this.attr('href')).hide();
                }
            });
        };
        var showTab = function (id) {
            hideTabs();
            $(id).show();
            $t.find('a[data-ui=tabs-tab][href=' + id + ']').parent().addClass('active');
        };
        $t.find('a[data-ui=tabs-tab]').click(function (e) {
            e.preventDefault();
            showTab($(this).attr('href'));
            return false;
        });
        var ongletAAfficher = $t.find('.active > a');
        if (ongletAAfficher.length > 0) {
            showTab(ongletAAfficher.attr('href'));
        } else {
            showTab($($allLinks[0]).attr('href'));
        }
    });
})(jQuery.noConflict());
